import styled from 'styled-components';

export const TabbedNavigationWrapper = styled.div`
  margin-bottom: 0.25rem;
`;
